import React, { useEffect } from 'react';
import {MDBRow, MDBCol } from 'mdbreact';
import { withGoogleMap, GoogleMap, withScriptjs, InfoWindow, Marker } from "react-google-maps";
import Geocode from "react-geocode";
import Autocomplete from 'react-google-autocomplete';
import { useTranslation } from 'react-i18next';
import { GoogleMapsAPI } from '../client-config.js';
import 'assets/css/custom.css';
Geocode.setApiKey( GoogleMapsAPI );
Geocode.enableDebug();

const AsyncMap = withScriptjs(
	withGoogleMap(
		props => (
			
			<GoogleMap google={ props.google }
					   defaultZoom={ props.zoom }
					   defaultCenter={{ lat: Number(props.mapPosition.lat), lng: Number(props.mapPosition.lng) }}
			>
					<Autocomplete
					style={{
						width: '100%',
						height: '40px',
						paddingLeft: '16px',
						marginTop: '2px',
						marginBottom: '500px'
					}}
					onPlaceSelected={ props.onPlaceSelected }
					types={['(regions)']}
				/>
				<InfoWindow
					onClose={props.onInfoWindowClose}t
					position={{ lat: ( Number(props.markerPosition.lat) + 0.0018 ), lng: Number(props.markerPosition.lng) }}
				>
					<div>
						<span style={{ padding: 0, margin: 0 }}>
							{(Number(props.mapPosition.lat) !== 0 && Number(props.mapPosition.lng) !== 0) ? (props.address) : 'Enter minimal location details in below search box to enable drag option'  }</span>
					</div>
				</InfoWindow>
				<Marker google={props.google}
						name={'Dolores park'}
						draggable={true}
						onDragEnd={ props.onMarkerDragEnd }
						position={{ lat: Number(props.markerPosition.lat), lng: Number(props.markerPosition.lng) }}
				>
				</Marker> 
			</GoogleMap>
		)
	)
);
const Map = props => {
const { t, i18n } = useTranslation();


	useEffect(() => {
		
		Geocode.fromLatLng( props.mapPosition.lat , props.mapPosition.lng ).then(
			response => {
				const address = response.results[0].formatted_address,
				      addressArray =  response.results[0].address_components,
				      city = getCity( addressArray ),
				      area = getArea( addressArray ),
					  state = getState( addressArray ),
					  country = getCountry(addressArray);
					  props.setAddress(address);
					  props.setCity(city);
					  props.setArea(area);
					  props.setState(state);
					  props.setCountry(country);
			},
			error => {
				console.error( error );
			}
		);
	});

	const getCity = ( addressArray ) => {
		let city = '';
		for( let i = 0; i < addressArray.length; i++ ) {
			if ( addressArray[ i ].types[0] && 'administrative_area_level_2' === addressArray[ i ].types[0] ) {
				city = addressArray[ i ].long_name;
				return city;
			}
		}
	};
	
	const getArea = ( addressArray ) => {
		let area = '';
		for( let i = 0; i < addressArray.length; i++ ) {
			if ( addressArray[ i ].types[0]  ) {
				for ( let j = 0; j < addressArray[ i ].types.length; j++ ) {
					if ( 'sublocality_level_1' === addressArray[ i ].types[j] || 'locality' === addressArray[ i ].types[j] ) {
						area = addressArray[ i ].long_name;
						return area;
					}
				}
			}
		}
	};

	const getState = ( addressArray ) => {
		let state = '';
		for( let i = 0; i < addressArray.length; i++ ) {
			for( let i = 0; i < addressArray.length; i++ ) {
				if ( addressArray[ i ].types[0] && 'administrative_area_level_1' === addressArray[ i ].types[0] ) {
					state = addressArray[ i ].long_name;
					return state;
				}
			}
		}
	};

	const getCountry = ( addressArray ) => {
		let country = '';
		for( let i = 0; i < addressArray.length; i++ ) {
			for( let i = 0; i < addressArray.length; i++ ) {
				if ( addressArray[ i ].types[0] && 'country' === addressArray[ i ].types[0] ) {
					country = addressArray[ i ].long_name;
					return country;
				}				
			}
		}
	};

	const onInfoWindowClose = ( event ) => {

	};


	const onMarkerDragEnd = ( event ) => {
		const lat = event.latLng.lat(),
		    lng = event.latLng.lng();

		Geocode.fromLatLng( lat , lng ).then(
			response => {
				const address = response.results[0].formatted_address,
				      addressArray =  response.results[0].address_components,
				      city = getCity( addressArray ),
				      area = getArea( addressArray ),
					  state = getState( addressArray ),
					  country = getCountry ( addressArray );
				props.setAddress(address);
                props.setCity(city);
                props.setArea(area);
				props.setState(state);
				props.setCountry(country);
				props.setMarkerPosition({
                    lat,
                    lng
				});
                props.setMapPosition({
                    lat,
                    lng
				});
			},
			error => {
				console.error(error);
			}
		);
	};

	const onPlaceSelected = ( place ) => {
		const address = place.formatted_address,
		      addressArray =  place.address_components,
		      city = getCity( addressArray ),
		      area = getArea( addressArray ),
			  state = getState( addressArray ),
			  country = getCountry( addressArray ),
		      lat = place.geometry.location.lat(),
		      lng = place.geometry.location.lng();
			  props.setAddress(address);
			  props.setCity(city);
			  props.setArea(area);
			  props.setState(state);
			  props.setMarkerPosition({
				lat,
				lng
			  });
			  props.setMapPosition({
				lat,
				lng
			});
	};

		
		let map;
		if( props.center.lat !== undefined ) {
			map = <div>
			
				<AsyncMap
					googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GoogleMapsAPI}&libraries=places`}
					loadingElement={
						<div style={{ height: `78%` }} />
					}
					containerElement={
						<div style={{ height: props.height }} />
					}
					mapElement={
						<div style={{ height: `78%` }} />
					}
					mapPosition={props.mapPosition}
					markerPosition={props.markerPosition}
					address={props.address}
					onInfoWindowClose={onInfoWindowClose}
					onMarkerDragEnd={onMarkerDragEnd}
					onPlaceSelected={onPlaceSelected}
					zoom={props.zoom}
				/>
			
				<MDBRow>
					<MDBCol md="6" className="mb-6">
					<div className="form-group">
						<label htmlFor="" style={{fontWeight: '400'}}>{`${t("maps.latitude")}`}</label>
						<input type="text" name="latitude" className="form-control" onChange={e => props.setMapPosition.lat(e.target.value)} readOnly="readOnly" value={ props.mapPosition.lat }/>
					</div>
					</MDBCol>
					<MDBCol md="6" className="mb-6">
					<div className="form-group">
						<label htmlFor="" style={{fontWeight: '400'}}>{`${t("maps.longitude")}`}</label>
						<input type="text" name="longitude" className="form-control" onChange={e => props.setMapPosition.lng(e.target.value)} readOnly="readOnly" value={ props.mapPosition.lng }/>
					</div>
					</MDBCol>
				</MDBRow>
				<MDBRow>
					<MDBCol md="6" className="mb-6">
					<div className="form-group">
						<label htmlFor="" style={{fontWeight: '400'}}>{`${t("maps.country")}`}</label>
						<input type="text" name="country" className="form-control" onChange={e => props.setCountry(e.target.value)} readOnly="readOnly" value={ props.country }/>
					</div>
					</MDBCol>
					<MDBCol md="6" className="mb-6">
					<div className="form-group">
						<label htmlFor="" style={{fontWeight: '400'}}>{`${t("maps.state")}`}</label>
						<input type="text" name="state" className="form-control" onChange={e => props.setState(e.target.value)} readOnly="readOnly" value={ props.state }/>
					</div>
					</MDBCol>
				</MDBRow>
				<MDBRow>
					<MDBCol md="6" className="mb-6">
					<div className="form-group">
						<label htmlFor="" style={{fontWeight: '400'}}>{`${t("maps.city")}`}</label>
						<input type="text" name="city" className="form-control" onChange={e => props.setCity(e.target.value)} readOnly="readOnly" value={ props.city }/>
					</div>
					</MDBCol>
					<MDBCol md="6" className="mb-6">
					<div className="form-group">
						<label htmlFor="" style={{fontWeight: '400'}}>{`${t("maps.area")}`}</label>
						<input type="text" name="area" className="form-control" onChange={e => props.setArea(e.target.value)} readOnly="readOnly" value={ props.area }/>
					</div>
					</MDBCol>
				</MDBRow>
				<MDBRow>
					<MDBCol md="12" className="mb-12">
					<div className="form-group">
						<label htmlFor="" style={{fontWeight: '400'}}>{`${t("maps.address")}`}</label>
						<input type="text" name="address" className="form-control" onChange={e => props.setAddress(e.target.value)} readOnly="readOnly" value={ props.address }/>
					</div>
					</MDBCol>
				</MDBRow>
				
			</div>
		} else {
			map = <div style={{height: props.height}} />
		}
		return( map )
}
const comparator = (prevProps, nextProps) => {
    if (prevProps.markerPosition.lat !== nextProps.setProps.markerPosition.lat) {
        return true;
      }
      if (prevProps.address !== nextProps.setProps.address) {
        return true;
      }
      if (prevProps.city !== nextProps.setProps.city) {
        return true;
      }
      if (prevProps.area !== nextProps.setProps.area) {
        return true;
      }
      if (prevProps.state !== nextProps.setProps.state) {
        return true;
      }
      return false;
  }
const sam = React.memo(AsyncMap, comparator);

export default Map